import { useState, useEffect } from "react";
import realtimeDB from "../Utils/api";

const useCartaPagePhotos = () => {
    const [Photos, setPhotos] = useState([]);

    const getHorario = (Hora, Minutos) => {
        return Hora + Minutos / 60;
    }

    const getHorarioDB = (horaMinutos) => {
        const [Hora, Minutos] = horaMinutos.split(":");
        return getHorario(Number(Hora), Number(Minutos));
    }

    const isInTimeRange = (currentTime, startTime, endTime) => {
        if (startTime <= endTime) {
            return currentTime >= startTime && currentTime <= endTime;
        } else {
            return currentTime >= startTime || currentTime <= endTime;
        }
    }

    useEffect(() => 
    {
        const getPhotos = async () => 
        {
            const { HH, cena, noche, madrugada } = (await realtimeDB.ref(`/HorariosCarta/`).once("value")).val();

            const HoraActual = new Date().getHours();
            const MinutosActuales = new Date().getMinutes();

            const HorarioActual = getHorario(HoraActual, MinutosActuales);

            const DiaNumeroActual = new Date().getDay();


            const DiaActual = ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado"][DiaNumeroActual];

            const HorariosHH = HH[DiaActual];
            const HorariosCena = cena[DiaActual];
            const HorariosNoche = noche[DiaActual];
            const HorariosMadrugada = madrugada[DiaActual]

            const rangeHorariosHH = [getHorarioDB(HorariosHH.start), getHorarioDB(HorariosHH.end)];
            const isInRangeHH = isInTimeRange(HorarioActual, rangeHorariosHH[0], rangeHorariosHH[1]);

            if (isInRangeHH) 
            {
                realtimeDB.ref(`/Cartas/HH`).on("value", (snapshot) => 
                {
                    const PhotosArray = [];
                    const photos = snapshot.val();
                    for (let key in photos) {
                        const photo = photos[key];
                        PhotosArray.push({ id: key, source: photo.source });
                    }
                    setPhotos(PhotosArray);
                });
            }

            const rangeHorariosCena = [getHorarioDB(HorariosCena.start), getHorarioDB(HorariosCena.end)];
            const isInRangeCena = isInTimeRange(HorarioActual, rangeHorariosCena[0], rangeHorariosCena[1]);

            if (isInRangeCena) 
            {
                realtimeDB.ref(`/Cartas/cena`).on("value", (snapshot) => 
                {
                    const PhotosArray = [];
                    const photos = snapshot.val();
                    for (let key in photos) {
                        const photo = photos[key];
                        PhotosArray.push({ id: key, source: photo.source });
                    }
                    setPhotos(PhotosArray);
                });
            }

            const rangeHorariosNoche = [getHorarioDB(HorariosNoche.start), getHorarioDB(HorariosNoche.end)];
            const isInRangeNoche = isInTimeRange(HorarioActual, rangeHorariosNoche[0], rangeHorariosNoche[1]);

            if (isInRangeNoche) 
            {
                realtimeDB.ref(`/Cartas/noche`).on("value", (snapshot) => 
                {
                    const PhotosArray = [];
                    const photos = snapshot.val();
                    for (let key in photos) {
                        const photo = photos[key];
                        PhotosArray.push({ id: key, source: photo.source });
                    }
                    setPhotos(PhotosArray);
                });
            }

            const rangeHorariosMadrugada = [getHorarioDB(HorariosMadrugada.start), getHorarioDB(HorariosMadrugada.end)];
            const isInrangeHorariosMadrugada = isInTimeRange(HorarioActual, rangeHorariosMadrugada[0], rangeHorariosMadrugada[1]);

            if (isInrangeHorariosMadrugada) 
            {
                realtimeDB.ref(`/Cartas/madrugada`).on("value", (snapshot) => 
                {
                    const PhotosArray = [];
                    const photos = snapshot.val();
                    for (let key in photos) {
                        const photo = photos[key];
                        PhotosArray.push({ id: key, source: photo.source });
                    }
                    setPhotos(PhotosArray);
                });
            }
        }

        getPhotos();
    }, []);

    return Photos;
}

export default useCartaPagePhotos;